import React from "react";
import { LiaTimesSolid } from "react-icons/lia";
import cn from "../../lib/cn";

const CloseButton = ({ onClick, className }) => {
    return (
        <div className={cn("flex justify-end", className)}>
            <button
                type="button"
                onClick={onClick}
                className="h-3 w-3 mb-1 rounded-full bg-gray-160  flex items-center justify-center text-primary text-xl"
            >
                <LiaTimesSolid size={25} />
            </button>
        </div>
    );
};

export default CloseButton;
